const loadMoreButton = document.getElementById("load-more-btn");

if (loadMoreButton) {
    loadMoreButton.addEventListener("click", function() {
        // Mostrar las imágenes ocultas
        const showMoreContainer = document.getElementById('show-more-container');

        var hiddenImages = document.querySelectorAll(".media-grid__item .product-gallery__media.hidden");
        hiddenImages.forEach(function(image) {
            image.classList.remove("hidden");
        });
        
        // Ocultar el botón
        showMoreContainer.style.display = 'none';
    });
}


// Supongamos que las imágenes de producto están dentro de un contenedor con la clase 'product-gallery'
document.querySelectorAll(".product-gallery__media").forEach((item) => {
  item.addEventListener("click", (event) => {
    const position = parseInt(item.getAttribute("data-position"), 10);

    if (!isNaN(position)) {
      const gallery = item.closest(".product-gallery");

      if (gallery) {
        // Obtener la galería de imágenes filtradas
        const imageCells = Array.from(gallery.querySelectorAll(".product-gallery__carousel [data-media-type='image']"));

        // Buscar el índice real dentro de imageCells
        const index = imageCells.findIndex(cell => cell.getAttribute("data-position") == position);

        if (index !== -1) {
          gallery.dispatchEvent(
            new CustomEvent("lightbox:open", {
              bubbles: true,
              detail: { index }
            })
          );
        }
      }
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const button = document.querySelector('.seo-toggle');
  const desc = document.getElementById('seo-description');

  if (button && desc) {
    button.addEventListener('click', function () {
      const textExpanded = button.getAttribute('data-expanded');
      const textCollapsed = button.getAttribute('data-collapsed');

      if (desc.classList.contains('expanded')) {
        desc.classList.remove('expanded');
        button.textContent = textCollapsed;
      } else {
        desc.classList.add('expanded');
        button.textContent = textExpanded;
      }
    });
  }
});

